// Enable sticky footer fix when page content height is less than window height
var screen_h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
if (screen_h >= document.getElementById('content').clientHeight) {
  document.getElementsByTagName('body')[0].classList.add('sticky-footer');
}
